import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { doc, setDoc, getDoc, onSnapshot, runTransaction } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

export const addNotification = createAsyncThunk(
  'notifications/addNotification',
  async ({ uid, notification }) => {
    try {
      const docRef = doc(db, 'users', uid, 'data', 'notifications');
      await runTransaction(db, async (transaction) => {
        const docSnap = await transaction.get(docRef);
        const notifications = [];
        if (docSnap.exists()) {
          let i = 0;
          while (docSnap.data()[i]) {
            notifications.push(docSnap.data()[i]);
            i++;
          }
        }
        notifications.push({ ...notification, createdAt: Date.now() });
        transaction.set(docRef, { ...notifications });
      });
    } catch (error) {
      return error;
    }
  }
);

export const subscribeToNotifications = (uid, dispatch) => {
  const docRef = doc(db, 'users', uid, 'data', 'notifications');
  
  const unsubscribe = onSnapshot(docRef, (docSnap) => {
    const notifications = [];
    if (docSnap.exists()) {
      let i = 0;
      while (docSnap.data()[i]) {
        notifications.push(docSnap.data()[i]);
        i++;
      }
    }
    dispatch(setNotifications(notifications));
  });

  return unsubscribe;
};

export const updateNotifications = createAsyncThunk(
  'notifications/updateNotifications',
  async ({ uid, notifications }) => {
    try {
      await setDoc(doc(db, 'users', uid, 'data', 'notifications'), {
        ...notifications
      });
      return notifications;
    } catch (error) {
      return error;
    }
  }
);

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async (uid) => {
    try {
      const notifications = [];
      const docSnap = await getDoc(doc(db, 'users', uid, 'data', 'notifications'));
      if (docSnap.exists()) {
        let i = 0;
        while (docSnap.data()[i]) {
          notifications.push(docSnap.data()[i]);
          i++;
        }
      }
      return notifications;
    } catch (error) {
      return error;
    }
  }
);

const initialState = [];

export const notificationSlice = createSlice({
  name: 'notifications',
  initialState: initialState,
  reducers: {
    resetNotifications() {
      return initialState;
    },
    setNotifications(state, action) {
      return { ...state, notifications: action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateNotifications.fulfilled, (state, action) => {
        return (state = {
          ...state,
          notifications: action.payload
        });
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        return (state = {
          ...state,
          notifications: action.payload
        });
      });
  }
});

export const { resetNotifications, setNotifications  } = notificationSlice.actions;
export default notificationSlice.reducer;
